import { Calendar, Zap } from 'lucide-react'
import { Card } from '@/components/ui/card'
import type { Bolletta } from '@/lib/graphql/types'

export function InvoiceInfoRow({ invoice }: { invoice: Bolletta }) {
  const consumo = invoice.consumo != null ? Number(invoice.consumo).toFixed(2) : null
  return (
    <div className="grid grid-cols-2 gap-3">
      <Card className="flex flex-col items-center p-4">
        <Calendar className="h-5 w-5 text-secondary" />
        <p className="mt-1 text-xs uppercase tracking-wider text-muted-foreground">
          Scadenza
        </p>
        <p className="mt-0.5 text-sm font-semibold text-foreground">
          {invoice.data_scadenza || '—'}
        </p>
      </Card>
      <Card className="flex flex-col items-center p-4">
        <Zap className="h-5 w-5 text-tertiary" />
        <p className="mt-1 text-xs uppercase tracking-wider text-muted-foreground">
          Consumo
        </p>
        <p className="mt-0.5 text-sm font-semibold text-foreground">
          {consumo ? `${consumo} kWh` : '—'}
        </p>
      </Card>
    </div>
  )
}
